import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ErrorModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <span className='text-danger'>Erreur serveur</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='text-danger'>
          Erreur lors de l'envoi de vos données vers notre serveur. Veuillez réessayer dans quelques minutes.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={props.onHide}>Fermer</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorModal